import { TableRow, TableCell, Typography, Alert } from '@mui/material'
import type { FC } from 'react'

interface Props {
  colSpan: number
  errorMessage?: string
}

const Error: FC<Props> = ({
  colSpan,
  errorMessage = 'An unexpected error occurred.',
}) => (
  <TableRow>
    <TableCell component="th" scope="row" colSpan={colSpan} sx={{ verticalAlign: 'top' }}>
      <Alert severity="error">
        <Typography variant="body2">{errorMessage}</Typography>
      </Alert>
    </TableCell>
  </TableRow>
)

export default Error
